import { AxiosResponse } from 'axios'
import axios from '@/services/axios'
import type {
  TransactionInterface,
  TransactionListParams,
  TransactionRestorePayload,
} from '@/models/shop/TransactionV2.types'

export default abstract class TransactionsApi {
  public static route = process.env.VUE_APP_SHOP_V2_BASE_URI
  public static entity = 'transactions'

  public static async list(
    arenaId: string,
    params: TransactionListParams,
  ): Promise<
    AxiosResponse<{
      data: TransactionInterface[]
      metadata: { count: number; page: number; size: number; sort: string }
    }>
  > {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}`
    return await axios.get(url, { params })
  }

  public static async get(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse<TransactionInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}`
    return await axios.get(url)
  }

  public static async restore(
    arenaId: string,
    id: string,
    data: TransactionRestorePayload,
  ): Promise<AxiosResponse<TransactionInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/restore`
    return await axios.post(url, data)
  }
}
